export default __webpack_public_path__ + "static/media/photo-tools.30dae586.jpeg";